import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Empty = () => (
  <p className="CollectionParent__empty">
    {I18n.localize('collectionPage.empty')}
    <style jsx>
      {`
        .CollectionParent__empty {
          text-align: center;
          margin: ${Theme.get('spacing') * 6}px 0;
          letter-spacing: ${Theme.get('letter-spacing-px')};
          line-height: 1.5;
        }
      `}
    </style>
  </p>
);

export default Empty;
